import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight, FaFilePdf } from 'react-icons/fa';

import styled from 'styled-components';

import PDF1 from '../../Tables/Tabledata/Drawings/IE-2470-110.pdf';
import IE110 from '../../Tables/Tabledata/Drawings/IE-2470-110.pdf';
import IE111 from '../../Tables/Tabledata/Drawings/IE-2470-111.pdf';
import IE112 from '../../Tables/Tabledata/Drawings/IE-2470-112.pdf';
import IE113 from '../../Tables/Tabledata/Drawings/IE-2470-113.pdf';
import IE114 from '../../Tables/Tabledata/Drawings/IE-2470-114.pdf';
import IE510 from '../../Tables/Tabledata/Drawings/IE-2470-510.pdf';
import IE810 from '../../Tables/Tabledata/Drawings/IE-2470-810.pdf';
import IO000 from '../../Tables/Tabledata/Drawings/IO-2470-000.PDF';
import IO201 from '../../Tables/Tabledata/Drawings/IO-2470-201.PDF';
import IO202 from '../../Tables/Tabledata/Drawings/IO-2470-202.PDF';
import IO203 from '../../Tables/Tabledata/Drawings/IO-2470-203.PDF';
import IO204 from '../../Tables/Tabledata/Drawings/IO-2470-204.PDF';
import IO205 from '../../Tables/Tabledata/Drawings/IO-2470-205.PDF';
import IO221 from '../../Tables/Tabledata/Drawings/IO-2470-221.PDF';
import IO222 from '../../Tables/Tabledata/Drawings/IO-2470-222.PDF';
import IO600 from '../../Tables/Tabledata/Drawings/IO-2470-600.PDF';
import IO700 from '../../Tables/Tabledata/Drawings/IO-2470-700.PDF';
import IO2100 from '../../Tables/Tabledata/Drawings/IO-2470-700.PDF';
import IT000 from '../../Tables/Tabledata/Drawings/IT-2470-000.pdf';

const TableComp = ({ className, tablesorter }) => {
	let classes = { className };
	if (tablesorter) {
		classes += 'tablesorter';
	}

	return (
		<table id="yourTable" class={classes} style={{ width: '100%' }}>
			<thead>
				<tr>
					<th>Equipment Description</th>
					<th>Drawing Number</th>
					<th className="filter-select">Drawing Type</th>
					<th style={{ width: '6vw' }}>Drawing File</th>
				</tr>
			</thead>
			<tbody>
				{/* <tr>
					<td>Power Distribution Panel (PDP)</td>
					<td>IE-2470-110</td>
					<td>Electrical</td>
					<td>
						<a href={IE110} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>Transformer Stand</td>
					<td>IO-2454-952</td>
					<td>Electrical</td>
					<td>
						<a href={I0952} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				<tr>
					<td>Sola Transformer 10kVA 480/240 /120 VAC</td>
					<td>IE-2470-110</td>
					<td>Electrical</td>
					<td>
						<a href={IE110} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Sola Transformer 7.5kVA 480/240 /120 VAC</td>
					<td>IE-2470-110</td>
					<td>Electrical</td>
					<td>
						<a href={IE110} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Sola Transformer 7.5kVA 480/240 /120 VAC</td>
					<td>IE-2470-110</td>
					<td>Electrical</td>
					<td>
						<a href={IE110} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Allen-Bradley Transformer 5kVA 480/120VAC</td>
					<td>IE-2470-110</td>
					<td>Electrical</td>
					<td>
						<a href={IE110} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Programmable Automation Controller (PAC)</td>
					<td>IE-2470-111</td>
					<td>Electrical</td>
					<td>
						<a href={IE111} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Server Panel (SP)</td>
					<td>IE-2470-112</td>
					<td>Electrical</td>
					<td>
						<a href={IE112} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trigger Panel 1 (TP1)</td>
					<td>IE-2470-113</td>
					<td>Electrical</td>
					<td>
						<a href={IE113} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Trigger Panel 2 (TP2)</td>
					<td>IE-2470-114</td>
					<td>Electrical</td>
					<td>
						<a href={IE114} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				{/* <tr>
					<td>Inspection Monitor (MON)</td>
					<td>IE-2470-200</td>
					<td>System Control</td>
					<td>
						<a href={IE200} target="_blank">
							<FaFilePdf />
						 class='file-link Pdf'</a>
					</td>
				</tr> */}
				<tr>
					<td>Human Machine Interface (HMI)</td>
					<td>IE-2470-510</td>
					<td>System Control</td>
					<td>
						<a href={IE510} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera – Univer Mounting Assembly</td>
					<td>IO-2470-000</td>
					<td></td>
					<td>
						<a href={IO000} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				{/* <tr>
					<td>Main Body Structure</td>
					<td>IO-2470-2000</td>
					<td></td>
					<td>
						<a href={IO2000} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				<tr>
					<td>Main Frame Clamp Assemblies</td>
					<td>IO-2470-2100</td>
					<td></td>
					<td>
						<a href={IO2100} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				{/* <tr>
					<td>Structure Clamp Assemblies - Perpendicular (Main Frame)</td>
					<td>IO-2470-320</td>
					<td></td>
					<td>
						<a href={IO320} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>Structure Clamp Assemblies - Vertical (Main Frame)</td>
					<td>IO-2470-321</td>
					<td></td>
					<td>
						<a href={IO321} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>Structure Clamp Assemblies -Mid Frame (Main Frame)</td>
					<td>IO-2470-323</td>
					<td></td>
					<td>
						<a href={IO323} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				<tr>
					<td>Camera Set 201</td>
					<td>IO-2470-201</td>
					<td></td>
					<td>
						<a href={IO201} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 202</td>
					<td>IO-2470-202</td>
					<td></td>
					<td>
						<a href={IO202} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 203</td>
					<td>IO-2470-203</td>
					<td></td>
					<td>
						<a href={IO203} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 204</td>
					<td>IO-2470-204</td>
					<td></td>
					<td>
						<a href={IO204} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 205</td>
					<td>IO-2470-205</td>
					<td></td>
					<td>
						<a href={IO205} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 221</td>
					<td>IO-2470-221</td>
					<td></td>
					<td>
						<a href={IO221} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Camera Set 222</td>
					<td>IO-2470-222</td>
					<td></td>
					<td>
						<a href={IO222} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Single Width Arch Light Assembly (Main Body)</td>
					<td>IO-2470-600</td>
					<td></td>
					<td>
						<a href={IO600} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				<tr>
					<td>Double Width Light Assembly (Main Body)</td>
					<td>IO-2470-700</td>
					<td></td>
					<td>
						<a href={IO700} target="_blank">
							<FaFilePdf size={50} class="file-link pdf" />
						</a>
					</td>
				</tr>
				{/* <tr>
					<td>Encoder Wheel Tracker</td>
					<td>IO-2454-902</td>
					<td></td>
					<td>
						<a href={IO902} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>AB Skid Detect Switch Bracket</td>
					<td>IO-9030-921</td>
					<td></td>
					<td>
						<a href={IO921} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>Part Detect Photoeye Assembly</td>
					<td>IO-2470-930</td>
					<td></td>
					<td>
						<a href={IO930} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
				{/* <tr>
					<td>Door Open Laser Assembly</td>
					<td>IO-2430-930</td>
					<td></td>
					<td>
						<a href={IO930} target="_blank">
							<FaFilePdf size={50} class='file-link Pdf' />
						</a>
					</td>
				</tr> */}
			</tbody>
			<tfooter id="pager" className="pager2" style={{}}>
				<form>
					<FaAngleDoubleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="first" alt="button" />
					<FaAngleLeft size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="prev" alt="button" />
					<input type="text" className="pagedisplay" alt="button" />
					<FaAngleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="next" alt="button" />
					<FaAngleDoubleRight size={30} style={{ color: '#000', margin: '.25rem .5rem' }} className="last" alt="button" />
					<select className="pagesize">
						<option selected="selected" value="10">
							10
						</option>
						<option value="20">20</option>
						<option value="30">30</option>
					</select>
				</form>
			</tfooter>
		</table>
	);
};

const Table = styled(TableComp)`
	.file-link {
		display: block;
		margin: 0 auto;
		color: green;
	}
`;

export default TableComp;
